module.exports = __webpack_public_path__ + "img/01-Cabrio-Roadster.140a33dc.svg";